<template>
  <div class="page-box">
    <PageSwiper location="SERVICE"/>

    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome"/>
      <div style="cursor: pointer;" @click="gotoHome">首页 > </div>
      <div class="text">服务案例</div>
    </div>

    <div class="case-detail">
      <div class="case-left">
        <div class="left-title">{{ caseDetail.name }}</div>
        <div v-html="$utils.escape2Html(caseDetail.content)"></div>
      </div>
      <div class="case-right">
        <div class="right-title">其他案例</div>
        <div class="right-item" v-for="(item, index) in caseData" :key="index" @click="gotoDetail(item)">
          <img :src="$utils.getFileHttpUrl(item.img)" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: { PageSwiper },
  data() {
    return {
      currentId: '',
      caseDetail: {},
      caseData: []
    }
  },
  created() {
    this.currentId = this.$route.params.id
    this.getCaseData()
    this.getData()
  },
  methods: {
    gotoHome() {
      this.$router.replace({name: 'home'})
    },
    getData() {
      this.$http.getAction(`/portal/api/v1/service/detail/${this.currentId}`).then((res) => {
        if (res.success) {
          this.caseDetail = res.data
        }
      })
    },
    getCaseData() {
      this.$http.getAction('/portal/api/v1/service').then((res) => {
        if (res.success) {
          this.caseData = res.data?.filter(item => item.id != this.currentId)
        }
      })
    },
    gotoDetail(record) {
      this.currentId = record.id
      this.getCaseData()
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 100px;
  background: #F5F5F5;
  flex: 1;

  .page-nav {
    display: flex;
    align-items: center;
    height: 80px;
    width: 1200px;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    margin: 0 auto;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .case-detail {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .case-left {
      border-top: 1px solid #D4D7D9;
      width: 770px;
      padding: 40px 0;
      .left-title {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 40px;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .case-right {
      width: 380px;
      .right-title {
        font-weight: 800;
        font-size: 20px;
        color: #0282DE;
        padding-bottom: 25px;
      }
      .right-item {
        cursor: pointer;
        img {
          width: 380px;
          height: 210px;
          object-fit: cover;
        }
        .name {
          height: 40px;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          line-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  
}
</style>
